export class UserDetail {
    manager: string
    manager_phone: string
    jsa_emergency_contact_phone: string

    // PTO fields
    sick_hours_given_ytd: number
    sick_hours_used_ytd: number    
    vacation_hours_offer: number
    vacation_hours_carry_over: number
    vacation_hours_given_ytd: number
    vacation_hours_used_ytd: number    

    constructor() {
    }
  
    static buildOne(obj: any): UserDetail {
      let target: UserDetail = Object.assign(new UserDetail(), obj)
      return target
    }

}
